module.exports = __webpack_public_path__ + "static/media/Dinero.9f19fef1.png";